<template>
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-1 overflow-y-scroll no-scrollbar -mx-4 px-4">
      <div class="button-group text-sm" v-auto-animate>
        <button :class="{ 'active': isToday }" @click="useUpdateQuery({ date: undefined, startDate: undefined, endDate: undefined })" v-if="!isToday">
          {{ useUcFirst($t('shared.today')) }}
        </button>
        <button :class="{ 'active': isWeekend, 'max-md:!hidden': route.query?.date }" @click="setWeekend()">
          {{ $t('shared.weekend') }}
        </button>
      </div>
      <EventsNavSchedule />
    </div>
    <EventsNavDate />
  </div>
</template>

<script async setup>
const dayjs = useDayjs()
const route = useRoute()

// Check active period
const isToday = computed(() => !route.query?.date && !route.query?.endDate && !route.query?.endDate)

// Check if period is weekend
const isWeekend = computed(() => !route.query?.date 
  && route.query?.startDate === dayjs().startOf('week').add(4, 'days').format('YYYY-MM-DD')
  && route.query?.endDate === dayjs().startOf('week').add(6, 'days').format('YYYY-MM-DD'))

// Check if period is next week
const isNextWeek = computed(() => !route.query?.date 
  && route.query?.startDate === dayjs().add(1, 'week').startOf('week').format('YYYY-MM-DD')
  && route.query?.endDate === dayjs().add(1, 'week').endOf('week').format('YYYY-MM-DD'))

// Set period to upcoming weekend
const setWeekend = () => {
  useUpdateQuery({ 
    date: undefined,
    startDate: dayjs().startOf('week').add(4, 'days').format('YYYY-MM-DD'), 
    endDate: dayjs().startOf('week').add(6, 'days').format('YYYY-MM-DD')
  })
}

// Set period to next week
const setNextWeek = () => {
  useUpdateQuery({ 
    date: undefined,
    startDate: dayjs().add(1, 'week').startOf('week').format('YYYY-MM-DD'), 
    endDate: dayjs().add(1, 'week').endOf('week').format('YYYY-MM-DD')
  })
}
</script>